export function debounce<T extends (...args: Parameters<T>) => void | Promise<void>>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) & { cancel: () => void } {
  let timeout: ReturnType<typeof setTimeout> | undefined

  function debounced(...args: Parameters<T>): void {
    if (timeout !== undefined) clearTimeout(timeout)
    timeout = setTimeout(() => {
      void func(...args)
    }, wait)
  }

  debounced.cancel = () => {
    if (timeout !== undefined) clearTimeout(timeout)
    timeout = undefined
  }

  return debounced as typeof debounced & { cancel: () => void }
}
